import { FC } from 'react'

import styled from 'styled-components'
import OutsideClickHandler from 'react-outside-click-handler'
import { Control, Controller } from 'react-hook-form'

import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { Input } from 'src/Components/Input/index.tsx'
import { colors, device } from 'src/Helpers/constants.ts'
import IconCirclePlus from 'src/Assets/addButton.svg?react'
import { SearchToolFormData } from 'src/Pages/Tools/index.tsx'

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 17px;
`

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  position: relative;
`

const StyledInput = styled(Input)`
  width: 500px;
  input {
    border: 1px solid ${colors.secondGray};
    color: ${colors.thirdBlue};
    --input-placeholder-color: ${colors.thirdBlue};
  }

  @media ${device.tabletMax} {
    width: 250px;
  }
`

const StyledButton = styled(IconButton)`
  svg {
    path {
      fill: ${colors.fourthBlue};
    }
  }
`

interface SearchBlockProps {
  onOpenAddModal: () => void
  control: Control<SearchToolFormData>
}
export const SearchBlock: FC<SearchBlockProps> = ({
  onOpenAddModal,
  control,
}) => {
  return (
    <OutsideClickHandler onOutsideClick={close}>
      <ControlsContainer>
        <StyledButton
          onClick={onOpenAddModal}
          tooltiptext={'Добавить навесное оборудование'}
          data-testid='add-tool'
        >
          <IconCirclePlus />
        </StyledButton>

        <FiltersContainer>
          <Controller
            name='searchString'
            control={control}
            render={({ field }) => (
              <StyledInput placeholder='Найти оборудование' {...field} />
            )}
          />
        </FiltersContainer>
      </ControlsContainer>
    </OutsideClickHandler>
  )
}
